import React from 'react';
import { StyledTextLink, StyledButtonLink, StyledButtonLabel } from './link.styled';
var LinkComponent = function LinkComponent(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, title = _ref.title, url = _ref.url;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, type === 'text' ? /*#__PURE__*/ React.createElement(StyledTextLink, {
        to: url
    }, title) : /*#__PURE__*/ React.createElement(StyledButtonLink, {
        to: url
    }, /*#__PURE__*/ React.createElement(StyledButtonLabel, null, title)));
};
export default LinkComponent;
